import {graphql, useStaticQuery} from 'gatsby';
import {parseTags, Tag, TagSet} from 'templates/content';

interface StaticResults {
	airtable: {
		data: {
			tags?: Tag[]
			tagSets?: TagSet[]
		}
	}
}

// Query for the meta tags configured on the home page
// and return those as the default to use if not defined
// for any particular page
const query = graphql`
query {
	airtable(
		table:{eq:"Pages"}
		queryName: {eq: "Pages"}
		data:{Path: {eq: "/"}}
	) {
		data {
			tags: Tags {
				data {
					name: Name
					property: Property
					content: Content
				}
			}
			tagSets: Tag_Sets {
				data {
					tags: Tags {
						data {
							name: Name
							property: Property
							content: Content
						}
					}
				}
			}
		}
	}
}`;

export const defaultTags = () => {
	const {airtable} = useStaticQuery<StaticResults>(query);
	return parseTags(airtable.data);
};
